import { render } from "./DocPreviewComponent.vue?vue&type=template&id=4175735b&ts=true"
import script from "./DocPreviewComponent.vue?vue&type=script&lang=ts"
export * from "./DocPreviewComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__